import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { fetchGroupsAction, fetchGroupsFailure } from '../actions';
import ErrorContainer from '../components/ErrorContainer';

class GroupSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      group_nm:        '',
      legacy_group_id: ''
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSearch() {
    const { group_nm, legacy_group_id } = this.state;
    if (_.isEmpty(group_nm.trim()) && _.isEmpty(legacy_group_id.trim())) {
      this.props.fetchGroupsFailure(['Atleast one field should be filled up']);
      return;
    }
    const data = {
      group_nm,
      legacy_group_id
    };
    this.props.fetchGroupsAction(data);
  }

  errors() {
    return (
      <div className="error">
        {this.props.errors.map((error, index) => <p key={index}>{error}</p>)}
      </div>
    );
  }

  renderGroups() {
    if (!this.props.groups || _.isEmpty(this.props.groups)) {
      return null;
    }
    return (
      <table>
        <thead>
          <tr>
            <th>Group Id</th>
            <th>Legacy Group Id</th>
            <th>Name</th>
            <th>Registration Group Code</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {this.props.groups.map(group => (
            <tr key={group.groupId}>
              <td>{group.groupId}</td>
              <td>{group.legacyGroupId}</td>
              <td>{group.groupNm}</td>
              <td>{group.registrationGroupCd}</td>
              <td><a href={`/groups/${group.groupId}`}>Show</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="group_search">
        <h2>Search Groups</h2>
        <ErrorContainer errors={this.props.errors} />
        <div className="group_search_fields">
          <div className="label_container">
            <label htmlFor="group_nm">Group Name</label>
            <label htmlFor="legacy_group_id">Legacy Group Id</label>
          </div>
          <div className="field_container">
            <input
              name="group_nm"
              type="text"
              value={this.state.group_nm}
              onChange={e => this.handleChange(e)}
            />
            <input
              name="legacy_group_id"
              type="text"
              value={this.state.legacy_group_id}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="button_container">
          <button
            className="button search_button"
            type="button"
            onClick={() => this.handleSearch()}
            disabled={this.props.isSearching}
          >
            {this.props.isSearching ? 'Searching ...' : 'Search'}
          </button>
        </div>
        <div className="group_search_results">
          {this.renderGroups()}
        </div>
      </div>
    );
  }
}

GroupSearch.propTypes = {
  groups:             PropTypes.array,
  fetchGroupsAction:  PropTypes.func,
  errors:             PropTypes.array,
  fetchGroupsFailure: PropTypes.func,
  isSearching:        PropTypes.bool
};

const mapStateToProps = state => ({
  groups:      state.egrGroups.groups,
  errors:      state.egrGroups.errors,
  isSearching: state.egrGroups.isSearching
});

const mapDispatchToProps = { fetchGroupsAction, fetchGroupsFailure };

export default connect(mapStateToProps, mapDispatchToProps)(GroupSearch);
